<admin-breadcrumbs></admin-breadcrumbs>
<assignment-table
  [staticColumns]="staticColumns"
  [mutableColumns]="mutableColumns"
  [rows]="rows"
  [optionsResolver]="optionsResolver"
  [onUpdate]="onUpdate"
  [rowLabelFn]="rowLabelFn"
  [showSelectedChips]="false"
  [showUnassignedSection]="true"
  [unassignedGroups]="unassignedGroups"
  [hiddenGroups]="hiddenGroups"
  [onHiddenChange]="onHiddenChange"
  [loading]="loading"
  [loadError]="loadError"
  title="Facility Assignment"
  [subtitle]="subtitle"
  emptyStateMessage="No facilities found for your region."
></assignment-table>
